import type { Gate } from '../ir/types';
import type { RenderContext } from './types';

export function evaluateGate(
  gate: Gate | undefined,
  ctx: RenderContext | null,
): boolean {
  if (!gate) return true;
  const ability = ctx?.ability;
  if (!ability) return false;
  return ability.can(gate.action, gate.subject, gate.field);
}
